const VI_TRANSLATE = {
    Username: "Tên đăng nhập",
    Password: "Mật khẩu",
    Name: "Tên",
};

export default VI_TRANSLATE;